<div *ngIf="!rowData.isDraft">
  <p class="read">{{value.data}}</p>
</div>
<div *ngIf="rowData.isDraft">
  <input #input type="text" class="input" (keyup)="changeValue($event)">
</div>
